import { datadogRum } from "@datadog/browser-rum";
import { flagIsEnabled, getEnvironmentName, FLAG_NAMES } from "lib/environment";
import packageInfo from "../../../package.json";
import getEnvVariables from "lib/environmentVariables/getEnvVariables";

export function initializeDataDog() {
  if (flagIsEnabled(FLAG_NAMES.DATADOG_RUM_ENABLED)) {
    const environmentName = getEnvironmentName();

    datadogRum.init({
      applicationId: "7399b215-0e6d-4875-99fd-07cd38d95fd7",
      clientToken: "pub309f33a5fe1423e4be22431eaf275534",
      site: "datadoghq.com",
      service: "platform-identity-management-fe",
      env: environmentName,
      version: packageInfo.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask",
      actionNameAttribute: "data-pii-mask",
      enablePrivacyForActionName: true,
      allowedTracingUrls: [getEnvVariables().idApiUrl],
      traceSampleRate: 100,
    });
  }
}
